import { useLocation } from "wouter";
import { useEffect } from "react";
import { useCart } from "@/context/CartContext";

export const CartDrawer: React.FC<{ hideCartIcon?: boolean }> = ({ hideCartIcon = false }) => {
  const { items, removeFromCart, clearCart, open, closeCart } = useCart();
  const [location, navigate] = useLocation();
  // Auto-redirect to pricing if cart is emptied on /register
  useEffect(() => {
    if (location === "/register" && items.length === 0 && open) {
      closeCart();
      navigate("/");
    }
  }, [items, location, open, closeCart, navigate]);
  // Listen for registration success in iframe (postMessage or URL change)
  useEffect(() => {
    if (location !== "/register") return;
    function handleMessage(event: MessageEvent) {
      if (typeof event.data === "string" && event.data.includes("registration-success")) {
        closeCart();
        // Optionally, hide floating cart button via global state
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [location, closeCart]);
  // ... existing code ...

  // Only render if open
  if (!open) return null;

  return (
    <div className="fixed top-0 right-0 z-[200] w-full max-w-md h-full bg-[#101c16] shadow-2xl border-l border-[#14F195]/20 flex flex-col transition-transform duration-300" style={{ transform: open ? 'translateX(0)' : 'translateX(100%)' }}>
      <div className="flex items-center justify-between p-6 border-b border-[#14F195]/10">
        <h2 className="text-xl font-bold text-white">Your Cart</h2>
        <button onClick={closeCart} className="text-gray-400 hover:text-white text-2xl">&times;</button>
      </div>
      <div className="flex-1 overflow-y-auto p-6">
        {items.length === 0 ? (
          <div className="text-center text-gray-400 mt-12">
            Your cart is empty.<br />
            <button onClick={() => { closeCart(); navigate('/'); }} className="mt-4 px-4 py-2 bg-gradient-to-r from-[#9945FF] to-[#14F195] text-white rounded-lg font-bold">Continue Shopping</button>
          </div>
        ) : (
          <>
            <div className="flex items-center justify-between mb-6">
              <div>
                <div className="font-semibold text-white">Solana Volume Bot Free Trial</div>
                <div className="text-xs text-gray-400">7 days, full access</div>
              </div>
              <div className="flex items-center gap-1">
                <span className="font-bold text-green-400 text-lg">0</span>
                <span className="line-through text-gray-400 text-base ml-1">9</span>
                <span className="text-[#00FFA3] font-bold ml-1">SOL</span>
              </div>
            </div>
            <ul className="mb-6 space-y-1 text-white text-sm">
              <li>7 days, full access</li>
              <li>All DEX integrations</li>
              <li>Priority support</li>
              <li>Cancel anytime</li>
            </ul>
            <button
              onClick={() => {
                closeCart();
                navigate('/register');
              }}
              className="w-full bg-gradient-to-r from-[#9945FF] to-[#14F195] text-white py-3 rounded-xl font-bold text-lg mt-2 shadow-lg hover:opacity-90 transition"
            >
              Proceed to Registration
            </button>
          </>
        )}
      </div>
    </div>
  );
}; 